<template>
     <v-theme-provider dark>
          <base-section id="contact-us" class="secondary" space="36">
               <v-container>
                    <base-subheading
                         space="0"
                         class="green--text"
                         title="People Are Talking"
                         align="center"
                    />
                    <v-row align="center" justify="center">
                         <v-card
                              color="secondary"
                              dark
                              flat
                              tile
                              max-width="1600"
                              width="100%"
                         >
                              <v-window v-model="onboarding">
                                   <v-window-item
                                        v-for="(n, i) in cards"
                                        :key="`card-${i}`"
                                   >
                                        <v-card
                                             color="transparent"
                                             height="200"
                                        >
                                             <v-row
                                                  class="fill-height"
                                                  align="center"
                                                  justify="center"
                                             >
                                                  <v-card-text
                                                       class="text-center pb-10"
                                                  >
                                                       <v-rating
                                                            v-model="n.stars"
                                                            color="white"
                                                            dense
                                                            readonly
                                                            half-increments
                                                            hover
                                                            size="36"
                                                            class="pb-5"
                                                       ></v-rating>
                                                       {{ n.review }}
                                                       <br />- {{ n.date }}
                                                       <base-subheading
                                                            space="0"
                                                            class="pt-3"
                                                            align="center"
                                                            :title="n.name"
                                                       ></base-subheading>
                                                  </v-card-text>
                                             </v-row>
                                        </v-card>
                                   </v-window-item>
                              </v-window>
                              <v-card-actions
                                   class="justify-space-between mt-10"
                              >
                                   <v-btn text @click="prev">
                                        <v-icon>mdi-chevron-left</v-icon>
                                   </v-btn>
                                   <v-item-group
                                        v-model="onboarding"
                                        class="text-center"
                                        mandatory
                                   >
                                        <v-item
                                             v-for="n in length"
                                             :key="`btn-${n}`"
                                             v-slot:default="{ active, toggle }"
                                        >
                                             <v-btn
                                                  :input-value="active"
                                                  icon
                                                  @click="toggle"
                                             >
                                                  <v-icon>mdi-record</v-icon>
                                             </v-btn>
                                        </v-item>
                                   </v-item-group>
                                   <v-btn text @click="next">
                                        <v-icon>mdi-chevron-right</v-icon>
                                   </v-btn>
                              </v-card-actions>
                         </v-card>
                    </v-row>
               </v-container>
          </base-section>
     </v-theme-provider>
</template>

<script>
export default {
     name: 'SectionNewsletterAlt',
     data: () => ({
          stars: 5,
          length: 3,
          onboarding: 0,
          cards: [
               {
                    review: `This necklace is so perfect - it’s lightweight and striking! Which is perfect
                                   for everyday wear if you love necklaces, or a
                                   simple statement necklace with a lot of
                                   impact! The color catches nicely in the
                                   light!`,
                    name: '~ Abby',
                    date: 'August 28, 2020',
                    stars: 5,
               },
               {
                    review: `It arrived very quickly! I like the make of this necklace and have been getting many compliments on it!`,
                    name: 'Lauren',
                    date: 'October 15, 2020',
                    stars: 5,
               },
               {
                    review: `I've gotten so many compliments on these earrings! I love them!`,
                    name: 'Lourdes',
                    date: 'September 1, 2020',
                    stars: 5,
               },
          ],
     }),
     methods: {
          next() {
               this.onboarding =
                    this.onboarding + 1 === this.length
                         ? 0
                         : this.onboarding + 1
          },
          prev() {
               this.onboarding =
                    this.onboarding - 1 < 0
                         ? this.length - 1
                         : this.onboarding - 1
          },
     },
}
</script>
